<template>
	<q-card
		class="q-py-sm cursor-pointer shadow-transition"
		:class="class_hover"
		@mouseover="class_hover = 'shadow-5'"
		@mouseleave="class_hover = ''"
		@click="showPreview()"
	>
		<q-card-section>
			<div class="row q-col-gutter-md">
				<div class="col-12">
					<q-icon
						:name="$extensionIcon(this.material.extension).icon"
						size="lg"
						:color="$extensionIcon(this.material.extension).color"
					/>
				</div>

				<div class="col-12">
					<span class="text-h5 title">
						{{ material.title }}
					</span>
					<span class="text-grey-6"> {{ $t(getType) }} - {{ material.size }} </span>
				</div>
			</div>
		</q-card-section>
	</q-card>
</template>

<script>
export default {
	name: 'CoursesSupportMaterialDesktop',

	props: ['material', 'type'],

	data() {
		return {
			class_hover: '',
			hover: false,
		}
	},

	computed: {
		getType() {
			switch (this.material.extension) {
				case 'wmv':
				case 'mkv':
				case 'mov':
				case 'mp4':
					return 'video'
					break
				case 'wav':
				case 'ogg':
				case 'mp3':
					return 'audio'
					break
				case 'pdf':
					return 'pdf_file'
					break
				case 'png':
				case 'jpg':
				case 'jpeg':
				case 'bmp':
				case 'svg':
				case 'gif':
					return 'image'
					break
				case 'zip':
				case 'rar':
				case 'gzip':
				case 'tz':
					return 'compressed_file'
					break
				case 'xlsx':
				case 'xls':
					return 'excel_file'
					break
				case 'docx':
				case 'txt':
				case 'doc':
					return 'document'
					break
				case 'pptx':
				case 'ppt':
					return 'powerpoint_file'
				default:
					return 'file'
					break
			}
		},
	},

	methods: {
		showPreview() {
			this.$emit('showPreview', this.material)
		},

		downloadFile() {
			this.$emit('downloadFile', this.material)
		},
	},
}
</script>

<style lang="scss" scoped>
.title {
	font-size: 0.905rem;
	font-weight: 800;
	line-height: 1.2rem;
	display: -webkit-box;
	min-height: 38px;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
</style>
